const CAPACITY_IS_FULL = 'CAPACITY_IS_FULL';
const ONE_APPOINTMENT_PER_SERVICE = 'ONE_APPOINTMENT_PER_SERVICE';
const DEFAULT = 'DEFAULT';


export const reasons = {
  CAPACITY_IS_FULL,
  ONE_APPOINTMENT_PER_SERVICE,
  DEFAULT,
};

export const titleText = {
  [ONE_APPOINTMENT_PER_SERVICE]: {
    id: 'Appointments.Create.MoreThan1Appt.Alert.Title',
    defaultMessage: '** Could not create appointment',
  },
  [CAPACITY_IS_FULL]: {
    id: 'Appointments.Create.FullQueue.Dialog.Title',
    defaultMessage: '** Unscheduled queue is full',
  },
  [DEFAULT]: {
    id: 'Appointments.Create.Fail.Alert.Title',
    defaultMessage: '** Could not create appointment',
  },
};

export const bodyText = {
  [ONE_APPOINTMENT_PER_SERVICE]: {
    id: 'Appointments.Create.MoreThan1Appt.Alert.Body',
    defaultMessage: '** User can not create more than 1 appointment per service.',
  },
  [CAPACITY_IS_FULL]: {
    id: 'Appointments.Create.FullQueue.Dialog.Body',
    defaultMessage: '** Service queue is full and appointment can not be created. Please try again later',
  },
  [DEFAULT]: {
    id: 'Appointments.Create.Fail.Alert.Body',
    defaultMessage: '** Appointment could not be created. Please try again later or contact your admin.',
  },
};

export const buttonText = {
  [ONE_APPOINTMENT_PER_SERVICE]: {
    id: 'General.Close',
    defaultMessage: '** Close',
  },
  [CAPACITY_IS_FULL]: {
    id: 'General.Ok',
    defaultMessage: '** Ok',
  },
  [DEFAULT]: {
    id: 'General.Close',
    defaultMessage: '** Close',
  },
};
